var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4384 53.4258L41.3157 42.3032L52.4384 31.1805C53.5564 30.0625 53.5564 28.2565 52.4384 27.1385C51.9028 26.6017 51.1757 26.3 50.4174 26.3C49.6591 26.3 48.932 26.6017 48.3964 27.1385L35.2384 40.2965C34.1204 41.4145 34.1204 43.2205 35.2384 44.3385L48.3964 57.4965C49.5144 58.6145 51.3204 58.6145 52.4384 57.4965C53.5277 56.3785 53.5564 54.5438 52.4384 53.4258Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeft);
export default __webpack_public_path__ + "static/media/keyboard_arrow_left.3e48591d0db15bfdc6c24e1dffe6226e.svg";
export { ForwardRef as ReactComponent };